export const EMPRESAS = [
  { value: "autospa", label: "Auto Spa" },
  { value: "swstudio", label: "SW Studio" },
];

export const empresaLabel = (value) =>
  EMPRESAS.find((item) => item.value === value)?.label || "Sin asignar";
